import { makeStyles, css } from '@conexasaude/hero'

const callRestartedModalStyle = makeStyles({
  body({ colors }) {
    return css`
      color: ${colors.neutral[600]};
    `
  },
})

export default callRestartedModalStyle
